import {
  type CompleteStaffPasswordRecoveryDto,
  type PasswordRecoveryAcceptedResponseDto,
  type RequestStaffPasswordRecoveryDto,
  v2AuthControllerCompletePasswordRecovery,
  v2AuthControllerRequestPasswordRecovery
} from '@idc-forms/api-client'

const fallbackApiV2BaseUrl = import.meta.env.VITE_API_URL_NEST.replace(/\/api\/v1\/?$/, '')
const API_V2_BASE_URL = (import.meta.env.VITE_API_URL_V2 || fallbackApiV2BaseUrl).replace(/\/$/, '')

const requestOptions = {
  baseUrl: API_V2_BASE_URL,
  credentials: 'include' as const,
  throwOnError: true as const
}

export const passwordRecoveryV2Service = {
  request: async (
    body: RequestStaffPasswordRecoveryDto
  ): Promise<PasswordRecoveryAcceptedResponseDto> => {
    const result = await v2AuthControllerRequestPasswordRecovery({ ...requestOptions, body })
    return result.data
  },

  complete: async (body: CompleteStaffPasswordRecoveryDto): Promise<void> => {
    await v2AuthControllerCompletePasswordRecovery({ ...requestOptions, body })
  }
}
